var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 19.5,
    stroke: "#FFB900"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4854 19.2779C17.4854 17.8971 18.6046 16.7778 19.9854 16.7778C21.3661 16.7778 22.4854 17.8971 22.4854 19.2779C22.4854 20.6586 21.3661 21.7779 19.9854 21.7779C18.6046 21.7779 17.4854 20.6586 17.4854 19.2779Z",
    fill: "#FFB900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2634 29.7779L25.7635 24.2779C26.8512 23.1901 27.592 21.8041 27.8921 20.2954C28.1921 18.7866 28.0381 17.2227 27.4494 15.8014C26.8607 14.3802 25.8637 13.1655 24.5846 12.3108C23.3056 11.4562 21.8018 11 20.2634 11C18.7251 11 17.2213 11.4562 15.9422 12.3108C14.6631 13.1655 13.6662 14.3802 13.0775 15.8014C12.4887 17.2227 12.3347 18.7866 12.6348 20.2954C12.9349 21.8041 13.6756 23.1901 14.7634 24.2779L20.2634 29.7779Z",
    stroke: "#FFB900",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationHeader);
export default __webpack_public_path__ + "static/media/location-header.02fddea33d83896ee79a9d25ff786e87.svg";
export { ForwardRef as ReactComponent };